import {IFilter} from "../../../../domain/occasions/filters/IFilter";

export class StringFilter implements IFilter<string>{

    private value:string;

    constructor(){
        this.value = "";
    }

    public IsValid(value: string): boolean {
        if(value == null){
            return true;
        }
        return value.toLocaleLowerCase().includes(this.value);
    }

    public SetValue(value:string){
        this.value = value.toLocaleLowerCase();
    }

}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/occasions/filters/abstract/StringFilter.ts